import React from "react";
import {Col, Container, Row} from "react-bootstrap";
import {useNavigate} from "react-router-dom";
import Footer from "./Footer";
import {animationOnScroll} from "./animationOnScroll";


export default function Error() {
    const navigate = useNavigate();

        return (

        <div>
            <div className="footerBottom">
                <div className='content-container error'>
                    <Container fluid="xl" className="animation animation--bottom error--container">
                        <Row>
                            <Col lg={12}>
                                <h1>Es ist ein Fehler aufgetreten</h1>
                                <h3 onClick={()=> {
                                    navigate('/')
                                    animationOnScroll();
                                } } className="link m-0 align-self-center">Startseite</h3>
                            </Col>
                        </Row>
                    </Container>

                </div>
                <Footer/>

            </div>

        </div>
    )
};
